import { Box, Container, Typography, Button, Grid, Card, CardContent, Chip, Stack, Divider, AppBar, Toolbar, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  Handshake as HandshakeIcon,
  TrendingUp as TrendingUpIcon,
  Storefront as StorefrontIcon,
  AccountBalance as AccountBalanceIcon,
  Speed as SpeedIcon,
  Support as SupportIcon,
  Check as CheckIcon,
  Star as StarIcon,
  ArrowForward as ArrowForwardIcon,
  Inventory as InventoryIcon,
  People as PeopleIcon,
  Payments as PaymentsIcon,
  Rocket as RocketIcon,
} from '@mui/icons-material';

const PartnerLandingPage = () => {
  const navigate = useNavigate();

  const products = [
    {
      name: 'コエタス',
      description: '動画テスティモニアル収集ツール。顧客の声を動画で効率的に収集・公開。',
      category: 'Marketing',
      perUserFee: '¥300〜500/ユーザー',
      recommendedPrice: '¥4,980〜',
    },
    {
      name: 'Mireet',
      description: 'Zoom予約システム。Googleカレンダー連携、自動リマインダー、チーム日程調整。',
      category: 'Business',
      perUserFee: '¥300〜500/ユーザー',
      recommendedPrice: '¥2,980〜',
    },
    {
      name: 'MFM',
      description: 'マーケティング素材管理ツール。Googleドライブ連携、チーム共有、プロジェクト管理。',
      category: 'Marketing',
      perUserFee: '¥200〜400/ユーザー',
      recommendedPrice: '¥1,980〜',
    },
    {
      name: 'ポタサク',
      description: 'ポータルサイト作成ツール。ノーコードで業者検索サイトを構築。マルチテナント対応。',
      category: 'Web Builder',
      perUserFee: '¥500〜700/ユーザー',
      recommendedPrice: '¥9,800〜',
    },
    {
      name: 'LINE連携System',
      description: 'LINE公式アカウントとの連携システム。顧客管理、自動応答、セグメント配信。',
      category: 'Communication',
      perUserFee: '¥300〜500/ユーザー',
      recommendedPrice: '¥4,980〜',
    },
    {
      name: 'AI Chat Bot',
      description: 'AIチャットボット構築ツール。自社データで学習、Webサイトに簡単埋め込み。',
      category: 'AI Tools',
      perUserFee: '¥500〜700/ユーザー',
      recommendedPrice: '¥9,800〜',
    },
    {
      name: 'Authene',
      description: 'ライセンス認証・管理システム。SaaS・デスクトップアプリのライセンス管理を自動化。',
      category: 'Developer Tools',
      perUserFee: '¥300〜500/ユーザー',
      recommendedPrice: '¥3,980〜',
    },
    {
      name: 'hancoless',
      description: '電子契約・署名システム。契約書の作成から署名、管理まで完結。法的効力あり。',
      category: 'Business',
      perUserFee: '¥300〜500/ユーザー',
      recommendedPrice: '¥2,980〜',
    },
  ];

  const comingSoonProducts = [
    {
      name: '受発注システム',
      description: 'プロダクト管理・受発注を一元化。在庫管理、発注自動化、取引先連携。',
      category: 'Business',
    },
    {
      name: 'ウェブ広告自動解析',
      description: 'Google・Meta・Yahoo広告のデータを自動収集・分析。AI によるレポート生成。',
      category: 'Analytics',
    },
    {
      name: 'プロモーション戦略生成',
      description: 'AIがマーケティング戦略を自動生成。ターゲット分析、コンテンツ提案、施策立案。',
      category: 'AI Tools',
    },
  ];

  const benefits = [
    {
      icon: <StorefrontIcon sx={{ fontSize: 48 }} />,
      title: '自社ブランドで販売',
      description: '自社の顧客に、自社ブランドとして製品を販売。ホワイトラベル対応で、顧客との関係性を維持。',
    },
    {
      icon: <TrendingUpIcon sx={{ fontSize: 48 }} />,
      title: '自由な価格設定',
      description: '販売価格はあなたが決定。市場やターゲットに合わせた価格戦略が可能。',
    },
    {
      icon: <AccountBalanceIcon sx={{ fontSize: 48 }} />,
      title: 'シンプルな収益モデル',
      description: '売上からユーザー単価を引いた分があなたの収益。販売すればするほど利益が増加。',
    },
    {
      icon: <SpeedIcon sx={{ fontSize: 48 }} />,
      title: '即日販売開始',
      description: '承認後すぐに販売開始可能。決済システム・顧客管理は全て用意済み。',
    },
    {
      icon: <SupportIcon sx={{ fontSize: 48 }} />,
      title: '充実したサポート',
      description: '販売資料、マニュアル、技術サポートを提供。初めてでも安心。',
    },
    {
      icon: <HandshakeIcon sx={{ fontSize: 48 }} />,
      title: '長期的パートナーシップ',
      description: '製品アップデート、新機能追加の恩恵を受けながら、継続的に収益を獲得。',
    },
  ];

  const steps = [
    { number: '01', title: '申請', description: 'オンラインフォームから申請（2分）' },
    { number: '02', title: '審査', description: '2〜3営業日で審査完了' },
    { number: '03', title: '設定', description: 'Stripe連携・商品選択・価格設定' },
    { number: '04', title: '販売開始', description: '決済リンクを顧客に共有して販売！' },
  ];

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      {/* Header */}
      <AppBar position="fixed" sx={{ bgcolor: 'rgba(30, 30, 30, 0.95)', backdropFilter: 'blur(8px)' }}>
        <Container maxWidth="lg">
          <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 0 } }}>
            <Typography
              variant="h5"
              component="div"
              sx={{ fontWeight: 700, cursor: 'pointer' }}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              Gambit OEM Partner
            </Typography>
            <Stack direction="row" spacing={2} alignItems="center">
              <Button
                color="inherit"
                onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
              >
                製品一覧
              </Button>
              <Button
                color="inherit"
                onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
              >
                プラン
              </Button>
              <Button
                variant="contained"
                onClick={() => navigate('/partner/apply')}
                sx={{
                  bgcolor: '#FF6B35',
                  '&:hover': { bgcolor: '#E85A2A' },
                }}
              >
                パートナー申請
              </Button>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>

      <Toolbar />

      {/* Hero Section */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
          color: 'white',
          py: { xs: 10, md: 14 },
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={7}>
              <Chip
                label="OEMパートナープログラム"
                sx={{ bgcolor: 'rgba(255,107,53,0.2)', color: '#FF6B35', mb: 3, fontWeight: 600 }}
              />
              <Typography
                variant="h2"
                component="h1"
                sx={{
                  fontWeight: 800,
                  mb: 3,
                  fontSize: { xs: '2.5rem', md: '3.5rem' },
                  lineHeight: 1.2,
                }}
              >
                GambitのSaaS製品を
                <br />
                <Box component="span" sx={{ color: '#FF6B35' }}>自社ブランド</Box>で販売
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  mb: 4,
                  opacity: 0.9,
                  fontWeight: 400,
                  lineHeight: 1.6,
                }}
              >
                開発不要。すぐに販売開始。
                <br />
                売上からユーザー単価を引いた分が、あなたの収益に。
              </Typography>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => navigate('/partner/apply')}
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    bgcolor: '#FF6B35',
                    color: 'white',
                    px: 4,
                    py: 1.5,
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    boxShadow: '0 4px 14px rgba(255, 107, 53, 0.4)',
                    '&:hover': {
                      bgcolor: '#E85A2A',
                      boxShadow: '0 6px 20px rgba(255, 107, 53, 0.5)',
                    },
                  }}
                >
                  パートナー申請する
                </Button>
                <Button
                  variant="outlined"
                  size="large"
                  sx={{
                    borderColor: 'white',
                    color: 'white',
                    px: 4,
                    py: 1.5,
                    fontSize: '1.1rem',
                    '&:hover': {
                      borderColor: 'white',
                      bgcolor: 'rgba(255,255,255,0.1)',
                    },
                  }}
                  onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  製品を見る
                </Button>
              </Stack>
            </Grid>
            <Grid item xs={12} md={5}>
              <Card sx={{ bgcolor: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h6" color="white" gutterBottom>
                    収益シミュレーション
                  </Typography>
                  <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', my: 2 }} />
                  <Stack spacing={2}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography color="grey.400">販売価格（あなたが設定）</Typography>
                      <Typography color="white" fontWeight="bold">¥9,800/月</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography color="grey.400">ユーザー単価（Gambitへ）</Typography>
                      <Typography color="white">- ¥500/月</Typography>
                    </Box>
                    <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)' }} />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography color="white" fontWeight="bold">あなたの収益</Typography>
                      <Typography color="#4CAF50" fontWeight="bold" variant="h5">¥9,300/月</Typography>
                    </Box>
                  </Stack>
                  <Typography variant="caption" color="grey.500" sx={{ display: 'block', mt: 2 }}>
                    ※ 1ユーザーあたりの例。ユーザー数に応じて収益が増加
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* How It Works */}
      <Box sx={{ bgcolor: '#f8f9fa', py: { xs: 8, md: 12 } }}>
        <Container maxWidth="lg">
          <Typography variant="h3" align="center" sx={{ mb: 2, fontWeight: 700 }}>
            販売開始までの流れ
          </Typography>
          <Typography variant="h6" align="center" color="text.secondary" sx={{ mb: 8 }}>
            最短で翌営業日から販売開始
          </Typography>
          <Grid container spacing={3}>
            {steps.map((step, index) => (
              <Grid item xs={6} md={3} key={index}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography
                    variant="h2"
                    sx={{
                      fontWeight: 800,
                      color: 'rgba(255,107,53,0.2)',
                      mb: 1,
                    }}
                  >
                    {step.number}
                  </Typography>
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {step.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {step.description}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Products Section */}
      <Container maxWidth="lg" sx={{ py: { xs: 8, md: 12 } }} id="products">
        <Typography variant="h3" align="center" sx={{ mb: 2, fontWeight: 700 }}>
          販売できる製品
        </Typography>
        <Typography variant="h6" align="center" color="text.secondary" sx={{ mb: 8 }}>
          すべて日本語対応・日本円決済
        </Typography>
        <Grid container spacing={3}>
          {products.map((product, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: '100%',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4,
                  },
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Chip label={product.category} size="small" sx={{ mb: 2 }} />
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {product.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 3, minHeight: 48 }}>
                    {product.description}
                  </Typography>
                  <Divider sx={{ my: 2 }} />
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="caption" color="text.secondary">ユーザー単価</Typography>
                    <Typography variant="body2" fontWeight="bold">{product.perUserFee}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="caption" color="text.secondary">推奨販売価格</Typography>
                    <Typography variant="body2" fontWeight="bold" color="primary">{product.recommendedPrice}</Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Coming Soon Products */}
        <Typography variant="h4" align="center" sx={{ mt: 10, mb: 2, fontWeight: 700 }}>
          Coming Soon
        </Typography>
        <Typography variant="body1" align="center" color="text.secondary" sx={{ mb: 6 }}>
          今後追加予定の製品ラインナップ
        </Typography>
        <Grid container spacing={3} justifyContent="center">
          {comingSoonProducts.map((product, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: '100%',
                  bgcolor: 'grey.50',
                  border: '2px dashed',
                  borderColor: 'grey.300',
                  opacity: 0.9,
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                    <Chip label={product.category} size="small" />
                    <Chip label="Coming Soon" size="small" color="warning" variant="outlined" />
                  </Stack>
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {product.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ minHeight: 48 }}>
                    {product.description}
                  </Typography>
                  <Divider sx={{ my: 2 }} />
                  <Typography variant="body2" color="text.secondary" align="center" sx={{ fontStyle: 'italic' }}>
                    詳細は近日公開
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Benefits Section */}
      <Box sx={{ bgcolor: '#f8f9fa', py: { xs: 8, md: 12 } }}>
        <Container maxWidth="lg">
          <Typography variant="h3" align="center" sx={{ mb: 2, fontWeight: 700 }}>
            パートナーのメリット
          </Typography>
          <Typography variant="h6" align="center" color="text.secondary" sx={{ mb: 8 }}>
            開発不要で、SaaSビジネスをすぐに開始
          </Typography>
          <Grid container spacing={4}>
            {benefits.map((benefit, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card sx={{ height: '100%', textAlign: 'center', p: 2 }}>
                  <CardContent>
                    <Box sx={{ color: 'primary.main', mb: 2 }}>
                      {benefit.icon}
                    </Box>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      {benefit.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {benefit.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Pricing Section */}
      <Container maxWidth="lg" sx={{ py: { xs: 8, md: 12 } }} id="pricing">
        <Typography variant="h3" align="center" sx={{ mb: 2, fontWeight: 700 }}>
          パートナープラン
        </Typography>
        <Typography variant="h6" align="center" color="text.secondary" sx={{ mb: 8 }}>
          ビジネス規模に合わせて選択
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {/* Standard Plan */}
          <Grid item xs={12} md={5}>
            <Card sx={{ height: '100%', border: '1px solid', borderColor: 'divider' }}>
              <CardContent sx={{ p: 4 }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                  Standard
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="h3" component="span" fontWeight="800" color="primary">
                    ¥55,000
                  </Typography>
                  <Typography variant="body1" component="span" color="text.secondary">
                    /月（税別）
                  </Typography>
                </Box>
                <Divider sx={{ my: 3 }} />
                <List dense>
                  <ListItem disableGutters>
                    <ListItemIcon sx={{ minWidth: 36 }}><CheckIcon color="success" /></ListItemIcon>
                    <ListItemText primary="5商品まで販売可能" />
                  </ListItem>
                  <ListItem disableGutters>
                    <ListItemIcon sx={{ minWidth: 36 }}><CheckIcon color="success" /></ListItemIcon>
                    <ListItemText primary="ユーザー単価: ¥500〜700" />
                  </ListItem>
                  <ListItem disableGutters>
                    <ListItemIcon sx={{ minWidth: 36 }}><CheckIcon color="success" /></ListItemIcon>
                    <ListItemText primary="自由な価格設定" />
                  </ListItem>
                  <ListItem disableGutters>
                    <ListItemIcon sx={{ minWidth: 36 }}><CheckIcon color="success" /></ListItemIcon>
                    <ListItemText primary="決済リンク発行" />
                  </ListItem>
                  <ListItem disableGutters>
                    <ListItemIcon sx={{ minWidth: 36 }}><CheckIcon color="success" /></ListItemIcon>
                    <ListItemText primary="顧客管理機能" />
                  </ListItem>
                  <ListItem disableGutters>
                    <ListItemIcon sx={{ minWidth: 36 }}><CheckIcon color="success" /></ListItemIcon>
                    <ListItemText primary="売上レポート" />
                  </ListItem>
                </List>
                <Button
                  variant="outlined"
                  fullWidth
                  size="large"
                  onClick={() => navigate('/partner/apply')}
                  sx={{ mt: 3 }}
                >
                  このプランで申請
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Unlimited Plan */}
          <Grid item xs={12} md={5}>
            <Card
              sx={{
                height: '100%',
                border: '2px solid',
                borderColor: 'primary.main',
                position: 'relative',
              }}
            >
              <Chip
                label="おすすめ"
                color="primary"
                icon={<StarIcon />}
                sx={{
                  position: 'absolute',
                  top: -12,
                  left: '50%',
                  transform: 'translateX(-50%)',
                }}
              />
              <CardContent sx={{ p: 4 }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                  Unlimited
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="h3" component="span" fontWeight="800" color="primary">
                    ¥110,000
                  </Typography>
                  <Typography variant="body1" component="span" color="text.secondary">
                    /月（税別）
                  </Typography>
                </Box>
                <Divider sx={{ my: 3 }} />
                <List dense>
                  <ListItem disableGutters>
                    <ListItemIcon sx={{ minWidth: 36 }}><CheckIcon color="success" /></ListItemIcon>
                    <ListItemText primary="全商品販売可能" primaryTypographyProps={{ fontWeight: 'bold' }} />
                  </ListItem>
                  <ListItem disableGutters>
                    <ListItemIcon sx={{ minWidth: 36 }}><CheckIcon color="success" /></ListItemIcon>
                    <ListItemText primary="ユーザー単価: ¥300〜500（割引）" primaryTypographyProps={{ fontWeight: 'bold' }} />
                  </ListItem>
                  <ListItem disableGutters>
                    <ListItemIcon sx={{ minWidth: 36 }}><CheckIcon color="success" /></ListItemIcon>
                    <ListItemText primary="自由な価格設定" />
                  </ListItem>
                  <ListItem disableGutters>
                    <ListItemIcon sx={{ minWidth: 36 }}><CheckIcon color="success" /></ListItemIcon>
                    <ListItemText primary="決済リンク発行" />
                  </ListItem>
                  <ListItem disableGutters>
                    <ListItemIcon sx={{ minWidth: 36 }}><CheckIcon color="success" /></ListItemIcon>
                    <ListItemText primary="顧客管理機能" />
                  </ListItem>
                  <ListItem disableGutters>
                    <ListItemIcon sx={{ minWidth: 36 }}><CheckIcon color="success" /></ListItemIcon>
                    <ListItemText primary="売上レポート" />
                  </ListItem>
                  <ListItem disableGutters>
                    <ListItemIcon sx={{ minWidth: 36 }}><CheckIcon color="success" /></ListItemIcon>
                    <ListItemText primary="優先サポート" primaryTypographyProps={{ fontWeight: 'bold' }} />
                  </ListItem>
                </List>
                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  onClick={() => navigate('/partner/apply')}
                  sx={{
                    mt: 3,
                    bgcolor: '#FF6B35',
                    '&:hover': { bgcolor: '#E85A2A' },
                  }}
                >
                  このプランで申請
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* Revenue Model */}
      <Box sx={{ bgcolor: '#1a1a2e', color: 'white', py: { xs: 8, md: 12 } }}>
        <Container maxWidth="lg">
          <Typography variant="h3" align="center" sx={{ mb: 2, fontWeight: 700 }}>
            収益モデル
          </Typography>
          <Typography variant="h6" align="center" sx={{ mb: 8, opacity: 0.8 }}>
            シンプルで透明な仕組み
          </Typography>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Stack spacing={3}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <PaymentsIcon sx={{ fontSize: 40, color: '#FF6B35' }} />
                  <Box>
                    <Typography variant="h6" fontWeight="bold">売上は全額あなたに入金</Typography>
                    <Typography variant="body2" sx={{ opacity: 0.7 }}>顧客からの支払いは、まずあなたのStripeに入金</Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <PeopleIcon sx={{ fontSize: 40, color: '#FF6B35' }} />
                  <Box>
                    <Typography variant="h6" fontWeight="bold">月末にユーザー数を集計</Typography>
                    <Typography variant="body2" sx={{ opacity: 0.7 }}>アクティブユーザー数を自動でカウント</Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <InventoryIcon sx={{ fontSize: 40, color: '#FF6B35' }} />
                  <Box>
                    <Typography variant="h6" fontWeight="bold">ユーザー単価のみお支払い</Typography>
                    <Typography variant="body2" sx={{ opacity: 0.7 }}>ユーザー数 × 単価 をGambitにお支払い</Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <RocketIcon sx={{ fontSize: 40, color: '#4CAF50' }} />
                  <Box>
                    <Typography variant="h6" fontWeight="bold" color="#4CAF50">差額があなたの利益！</Typography>
                    <Typography variant="body2" sx={{ opacity: 0.7 }}>販売価格を高く設定するほど、利益が増加</Typography>
                  </Box>
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card sx={{ bgcolor: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)' }}>
                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h6" gutterBottom color="white">例：100ユーザーの場合</Typography>
                  <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)', my: 2 }} />
                  <Stack spacing={2}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography color="grey.300">月額売上（¥9,800 × 100人）</Typography>
                      <Typography fontWeight="bold" color="white">¥980,000</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography color="grey.300">Gambitへの支払い（¥500 × 100人）</Typography>
                      <Typography color="grey.100">- ¥50,000</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography color="grey.300">月額プラン料金</Typography>
                      <Typography color="grey.100">- ¥55,000</Typography>
                    </Box>
                    <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)' }} />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography fontWeight="bold" color="white">月間利益</Typography>
                      <Typography fontWeight="bold" variant="h4" color="#4CAF50">¥875,000</Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* CTA Section */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #FF6B35 0%, #E85A2A 100%)',
          color: 'white',
          py: { xs: 8, md: 10 },
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h3" align="center" sx={{ mb: 2, fontWeight: 700 }}>
            今すぐパートナーになる
          </Typography>
          <Typography variant="h6" align="center" sx={{ mb: 4, opacity: 0.9 }}>
            申請は2分で完了。審査後すぐに販売開始できます。
          </Typography>
          <Box sx={{ textAlign: 'center' }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate('/partner/apply')}
              endIcon={<ArrowForwardIcon />}
              sx={{
                bgcolor: 'white',
                color: '#FF6B35',
                px: 6,
                py: 2,
                fontSize: '1.2rem',
                fontWeight: 600,
                '&:hover': {
                  bgcolor: 'rgba(255,255,255,0.9)',
                },
              }}
            >
              パートナー申請する
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Footer */}
      <Box sx={{ bgcolor: '#0f0f1a', color: 'white', py: 6 }}>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Gambit OEM Partner Program
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.7 }}>
                GambitのSaaS製品を自社ブランドで販売できるパートナープログラム。
                <br />
                開発不要で、すぐにSaaSビジネスを開始できます。
              </Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                リンク
              </Typography>
              <Stack spacing={1}>
                <Typography
                  component="a"
                  href="/partner/apply"
                  variant="body2"
                  sx={{ opacity: 0.7, textDecoration: 'none', color: 'inherit', '&:hover': { opacity: 1 } }}
                >
                  パートナー申請
                </Typography>
                <Typography
                  component="a"
                  href="/login"
                  variant="body2"
                  sx={{ opacity: 0.7, textDecoration: 'none', color: 'inherit', '&:hover': { opacity: 1 } }}
                >
                  パートナーログイン
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                運営会社
              </Typography>
              <Stack spacing={1}>
                <Typography
                  component="a"
                  href="https://gambit.icu"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="body2"
                  sx={{ opacity: 0.7, textDecoration: 'none', color: 'inherit', '&:hover': { opacity: 1 } }}
                >
                  Gambit Inc.
                </Typography>
                <Typography
                  component="a"
                  href="mailto:partner@gambit.icu"
                  variant="body2"
                  sx={{ opacity: 0.7, textDecoration: 'none', color: 'inherit', '&:hover': { opacity: 1 } }}
                >
                  partner@gambit.icu
                </Typography>
              </Stack>
            </Grid>
          </Grid>
          <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', my: 4 }} />
          <Typography variant="body2" align="center" sx={{ opacity: 0.5 }}>
            &copy; {new Date().getFullYear()} Gambit Inc. All rights reserved.
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default PartnerLandingPage;
